<div
  id="shipment-info-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_310px)]"
>
  <div class="matp-table-area">
    <table
      id="shipment-info-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <!-- No. -->
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-min">
          <div class="matp-table-header-title tw-text-nowrap">No.</div>
        </th>
        <td
          mat-cell
          name="number"
          *matCellDef="let element; let i = index"
          class="tw-align-baseline"
        >
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- 配送名 -->
      <ng-container matColumnDef="shipmentName">
        <th mat-header-cell *matHeaderCellDef>
          <div
            mat-sort-header
            class="matp-table-header-title tw-min-w-[140px] tw-text-nowrap"
          >
            配送名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="shipmentName"
              type="text"
              [(ngModel)]="shipmentNameKeyword"
              (keyup)="dataSource.filter = shipmentNameKeyword"
            />
            <button
              id="shipmentName-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearShipmentNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="shipmentName"
          *matCellDef="let element"
          class="tw-align-baseline"
        >
          {{ element.shipmentName }}
        </td>
      </ng-container>

      <!-- 配送ステータス -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title tw-text-nowrap">
            <span mat-sort-header>配送ステータス</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="status"
              panelClass="matp-table-select-panel"
              [(ngModel)]="selectedShipmentStatus"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (uniqueStatus of uniqueStatusList; track uniqueStatus) {
                @if (getStatusDescription(uniqueStatus)) {
                  <mat-option [value]="uniqueStatus">{{
                    getStatusDescription(uniqueStatus)
                  }}</mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="status"
          *matCellDef="let element"
          class="tw-align-baseline"
        >
          {{ getStatusDescription(element.status) }}
        </td>
      </ng-container>

      <!-- 配送経路と現在位置 -->
      <ng-container matColumnDef="shipmentRouteAndCurrentLocation">
        <th mat-header-cell *matHeaderCellDef>
          <div
            mat-sort-header
            class="matp-table-header-title tw-text-nowrap tw-flex tw-items-center"
          >
            <div>配送の経路と日時</div>
            <div class="tw-h-[18px]">
              <mat-icon
                matTooltip="出発日時でソート"
                class="tw-ml-1 tw-text-[1.2em]"
                >info</mat-icon
              >
            </div>
          </div>
        </th>
        <td
          name="shipmentRouteAndCurrentLocation"
          mat-cell
          *matCellDef="let element"
        >
          @if (routeLoading) {
            <app-loading [loading]="routeLoading"></app-loading>
          } @else {
            <app-shipment-route-table
              [shipment]="element"
              [shipmentStatusHistory]="element.statusHistory ?? []"
            ></app-shipment-route-table>

            @if (showSensorAlertStartTime && element.sensorAlertStartTime) {
              <div class="tw-ml-4">
                センサーアラート取得開始時間：{{
                  element.sensorAlertStartTime | date: "yyyy/MM/dd HH:mm"
                }}
              </div>
            }
          }
        </td>
      </ng-container>

      <!-- デバイス名 -->
      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="deviceName"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="deviceNameKeyword"
              (keyup)="dataSource.filter = deviceNameKeyword"
            />
            <button
              id="deviceName-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          @for (
            device of element.deviceList;
            track device.deviceId;
            let last = $last
          ) {
            <a
              [routerLink]="['/device-info', device.deviceId]"
              [queryParams]="getDeviceInfoUrlParams(element)"
            >
              {{ device.deviceName || device.deviceId }}
            </a>

            @if (!last) {
              <span>, </span>
            }
          }

          @if (!element.deviceList) {
            <span>削除済デバイス</span>
          }
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title tw-text-nowrap">操作</div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="!tw-w-56 tw-align-baseline"
        >
          <div
            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-mt-1"
          >
            <button
              mat-stroked-button
              id="copy-btn"
              color="primary"
              class="!tw-min-w-48"
              (click)="opened.emit(element)"
              [disabled]="routeLoading"
            >
              @if (routeLoading) {
                <mat-icon class="tw-animate-spin">progress_activity</mat-icon>
              } @else {
                <mat-icon>map</mat-icon>
              }
              <span>アラート/地図表示</span>
            </button>

            @if (
              editableRole &&
              element.status &&
              element.status !== "Creating" &&
              (getAlert(element) === "NotReady" ||
                (element.status === "Create" && isToday(element.startDatetime)))
            ) {
              <button
                mat-stroked-button
                id="calc-route-btn"
                color="primary"
                class="!tw-min-w-48"
                (click)="statusGottenReady.emit(element.shipmentId)"
                [disabled]="!element.deviceList"
              >
                <mat-icon>check</mat-icon>
                <span>準備完了</span>
              </button>
            }

            @if (
              editableRole &&
              element.status &&
              (element.status === "AtStop" ||
                element.status === "InProgress")
            ) {
              <button
                mat-stroked-button
                id="calc-route-btn"
                color="primary"
                class="!tw-min-w-48"
                (click)="statusInterrupted.emit(element.shipmentId)"
                [disabled]="!element.deviceList"
              >
                <mat-icon>done_all</mat-icon>
                <span>配送中断</span>
              </button>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="asset-type-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>

  <div class="matp-table-area"></div>
</div>
